import React from "react";
import PropTypes from "prop-types";

const styles = {
  lgColorStart: {
    stopColor: "#000031"
  },
  lgColorMid: {
    stopColor: "#0A2C4F"
  },
  lgColorEnd: {
    stopColor: "#0064B1"
  },
  lg: {
    fill: "url(#SVGID_1_)"
  },
  rgColorStart: {
    stopColor: "#0053A5"
  },
  rgColorMid: {
    stopColor: "#00AEEF"
  },
  rgColorEnd: {
    stopColor: "#0064B1"
  },
  rg: {
    fill: "url(#SVGID_2_)"
  }
};

const Logo = props => (
  <svg width={props.size} height={props.size} viewBox="0 0 135 135" fill={props.color} style={props.style}>
    <g>
      <linearGradient
        id="SVGID_1_"
        gradientUnits="userSpaceOnUse"
        x1="-153.7495"
        y1="-68.8768"
        x2="-27.0583"
        y2="-68.8768"
        gradientTransform="matrix(0.9466 -0.3225 -0.3225 -0.9466 131.3745 -26.6683)"
      >
        <stop offset="0" style={styles.lgColorStart} />
        <stop offset="0.2732" style={styles.lgColorMid} />
        <stop offset="1" style={styles.lgColorEnd} />
      </linearGradient>
      <path
        style={styles.lg}
        d="M47.5,7.7C14.5,19-3.2,54.9,8.1,88.2s47.2,50.8,80.4,39.5s50.8-47.2,39.5-80.4S80.5-3.5,47.5,7.7z M70.1,111.8
		c-24.9,8.6-52-4.8-60.4-29.7c-8.6-24.9,4.8-52,29.7-60.4s52,4.8,60.4,29.7C108.3,76.2,95,103.4,70.1,111.8z"
      />
      <radialGradient id="SVGID_2_" cx="-95.253" cy="-68.6074" r="61.5477" gradientTransform="matrix(0.9466 -0.3225 -0.3225 -0.9466 131.3745 -26.6683)" gradientUnits="userSpaceOnUse">
        <stop offset="0" style={styles.rgColorStart} />
        <stop offset="0.5086" style={styles.rgColorMid} />
        <stop offset="1" style={styles.rgColorEnd} />
      </radialGradient>
      <path
        style={styles.rg}
        d="M103.3,113.4c-26.3,9-55.1-5-64.1-31.5c-9-26.3,5-55.1,31.5-64.1c13.4-4.6,27.2-3.1,38.9,2.5
		C93.1,5.4,69.3-0.2,46.7,7.5C13.5,18.8-4.3,54.9,7,88.2s47.4,51,80.6,39.7c12.7-4.4,23.2-12.3,30.7-22.6
		C114,108.6,109,111.3,103.3,113.4z"
      />
    </g>
  </svg>
);
Logo.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string
};
Logo.defaultProps = {
  size: "22px"
};

export default Logo;
